import { render, staticRenderFns } from "./GroupListVue.vue?vue&type=template&id=7725fa5c&"
import script from "./GroupListVue.vue?vue&type=script&lang=js&"
export * from "./GroupListVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports